import { module } from 'angular';
import App from '../../../app';

class SCR1906Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.httpService = httpService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(740, 560);
		this.initText();
		
		this.showResult(this.data);
		
//		this.$timeout(() => {
//			const $importFile = $('input:file');
//			
//			$importFile.on('change', (event) => {
//				const $importFile = $('input:file');
//				const files = $importFile[0].files;
//				
//				if(files === undefined) return;
//				if(files.length > 10) {
//					$importFile.val('');
//					this.popupService.simpleAlert(this.$scope, "파일은 10개까지 업로드할 수 있습니다.");
//					return;
//				}
//				
//				let fileNames = '';
//				
//				for(let i = 0; i < files.length; i++) {
//					fileNames += '[' + (i+1) + '] ' + files[i].name + '\r\n';
//				}
//				
//				$('.filenames').val(fileNames);
//			});
//		});
		
		
		
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			interfaceImport : bxMsg('manageMciInterface.interfaceImport'),
			interfaceFile : bxMsg('manageMciInterface.interfaceFile'),
			errorMessage : bxMsg('common.errorMessage'),
			close : bxMsg('common.close'),
			batchDeployResult : bxMsg('common.batchDeployResult')
		}
	}
	
	showResult(data){
		
		let filterResponse = data.resList.filter(v => v.res);
		this.allLen=0;
		this.successCnt = 0;
		this.failCnt = 0;
		
		filterResponse.map((data) => {
			if(!data.res.isError) {
				this.successCnt++;
			}else {
				this.failCnt++;
			}
		});
		
		this.allLen= this.successCnt + this.failCnt
		
		 this.isError = false;
		 this.testList = data.resList.map((data) => {
			 let fileConts = '';
			 data.intrfcId && (fileConts += '인터페이스 ID : ' );
			 data.intrfcId && (fileConts += data.intrfcId + ' ' + '\r\n');
			 data.res.data && (fileConts += data.res.data.message + '\r\n');
//			 data.res.parameters && (fileConts += data.res.data.parameters + '\r\n');
//			 data.res.data.parameters && (fileConts += data.res.data.parameters.map((param) => {
//				 return param + '\r\n';
//				 }));
			 
			 return {
				isError: !data.res.isError ? false : true,
				fileName: data.intrfcId,
				fileConts: fileConts
			 };
		 });
	}
	
	toggle(fileIndex, isError) {
		if(!isError) return;
		
		let $fileConts = $('#file' + fileIndex);
		
		if($fileConts.is(':visible')){
			$fileConts.hide();
		}else{
			$fileConts.show();
		}
	}
	
	openFile() {
		this.reset();
		$('input:file').click();
	}
	
	reset(){
		$('.filenames').val('');
		$('input:file').val('');
		this.isError = false;
		this.testList = [];
		this.uploadResult = ' ';
		this.uploadResultMsg = ' ';
	}
	
	closeModal(isOk){
		this.$uibModalInstance.dismiss();
	}
}

module(App.name).controller('SCR1906Controller', SCR1906Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1906/SCR1906.controller.js